import client from './client';

export async function getAssignOptions(approvalId) {
  const { data } = await client.get(`/step-submission-requests/${approvalId}/assign-options`);
  return data.data;
}

export async function approveAndAssign(approvalId, payload) {
  const { data } = await client.post(`/step-submission-requests/${approvalId}/approve-and-assign`, payload);
  return data.data;
}

export async function listMyAssignedJobs(params) {
  const { data } = await client.get('/assigned-jobs', { params });
  return data.data;
}

export async function myAssignedJobsCount() {
  const { data } = await client.get('/assigned-jobs/count');
  return data.data.count;
}

export async function listScheduledSteps(tab, params) {
  const { data } = await client.get('/scheduled-steps', { params: { ...params, tab } });
  return data.data;
}

export async function scheduledStepCounts() {
  const { data } = await client.get('/scheduled-steps/counts');
  return data.data;
}

export async function listAssignmentStaff(assignmentId) {
  const { data } = await client.get(`/scheduled-steps/${assignmentId}/staff`);
  return data.data;
}

export async function reassignStep(assignmentId, payload) {
  const { data } = await client.post(`/scheduled-steps/${assignmentId}/reassign`, payload);
  return data.data;
}
